import React from "react";
import deepakSharmaImg from "../../assets/images/png/about.png";
import BlueHeading from "../other/common/BlueHeading";
const AboutDeepak = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="flex items-center max-[992px]:flex-wrap-reverse gap-[67px] max-xl:gap-10 max-md:text-6 max-w-[1087px] mx-auto">
          <div className="w-full max-w-[523px]">
            <img
              src={deepakSharmaImg}
              alt="deepak-sharma"
              width={523}
              height={548}
              className="w-full pointer-events-none"
            />
          </div>
          <div className="w-full max-w-[497px] max-[992px]:max-w-full">
            <BlueHeading
              lineClassOne="!hidden"
              text="About Deepak Sharma"
              textClass="!text-[32px] max-md:!text-2xl"
            />
            <p className="text-[#5E5C5C] text-[26px] max-md:text-base font-normal leading-[150%] pt-4">
              Deepak Sharma is a visionary entrepreneur, real estate innovator,
              and the founder of Makeway India Group – a dynamic enterprise that
              has successfully left its mark across multiple industries. With an
              unwavering belief in growth, excellence, and purposeful living,
              Deepak Sharma has become a symbol of modern entrepreneurship fused
              with spiritual depth.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutDeepak;
